import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from 'src/app/admin/modules/users/data/services/account.service';
import { ToastrService } from 'ngx-toastr'; // ✅ Correct toastr service

@Component({
  selector: 'app-leadership-roles',
  templateUrl: './leadership-roles.component.html',
  styleUrls: ['./leadership-roles.component.sass']
})
export class LeadershipRolesComponent implements OnInit {
  leadershipForm: FormGroup;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private leadershipService: AccountService,
    private toastr: ToastrService // ✅ Use correct type
  ) {
    this.leadershipForm = this.fb.group({
      leadershipName: ['', Validators.required],
      postedBy: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Initialization logic can go here if needed
  }

  submitForm(): void {
    if (this.leadershipForm.invalid) {
      this.toastr.warning('Please fill all fields');
      return;
    }

    const { leadershipName, postedBy } = this.leadershipForm.value;
    this.loading = true;

    this.leadershipService.createLeadershipsRole(postedBy, leadershipName)
      .subscribe({
        next: (res) => {
          this.toastr.success('Leadership role added successfully');
          this.leadershipForm.reset();
        },
        error: (err) => {
          this.toastr.error('Failed to add leadership role');
          console.error(err);
        },
        complete: () => this.loading = false
      });
  }
}
